import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * The player node.
 * @type {HYPERCUBEJS.Node}
 * @constant
 */
const nodeplayer = new HYPERCUBEJS.Node();

/**
 * The state manager of the player node.
 * @type {import('@hypercubejs/hypercubejs').State<HYPERCUBEJS.Node>}
 * @constant
 */
const statenodeplayer = new HYPERCUBEJS.State(nodeplayer);

export {

    statenodeplayer
};

export default statenodeplayer;
